import React from 'react';
import ReactPaginate from 'react-paginate';
import propTypes from 'prop-types';

import { UilAngleDown, UilAngleLeft, UilAngleRight } from '@iconscout/react-unicons';

function Pagination({ list, items, onPageChange, currentPage, onChangePerPage, label, limit }) {
  // set show select
  const [showSelect, setShowSelect] = React.useState(false);
  // change value when click
  const [perPage, setPerpage] = React.useState(limit);
  // function set show select
  const changestateSelect = () => {
    setShowSelect(!showSelect);
  };
  // function selected value select
  const changeValueoption = (item) => {
    setPerpage(item.value);
    onChangePerPage(item.value);
    setShowSelect(false);
  };
  return (
    <div className="wrap-pagination mt-8" id="react-paginate">
      <ReactPaginate
        previousLabel={<UilAngleLeft color="#1F4BFF" />}
        nextLabel={<UilAngleRight color="#1F4BFF" />}
        breakLabel={'...'}
        breakClassName={'break-me'}
        pageCount={items}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={onPageChange}
        containerClassName={'pagination'}
        activeClassName={'active'}
        forcePage={currentPage - 1}
      />
      <p className="text-show mb-10">
        Showing
        {/* dropdown */}
        <button
          className="relative flex items-start ml-2 mr-3 outline-none focus:outline-none"
          onClick={() => changestateSelect()}
        >
          <span>{perPage}</span>
          <UilAngleDown color="#1F4BFF" />

          {showSelect === false ? (
            ''
          ) : (
            <ul className="flex flex-col absolute left-0 top-7 border border-gray-silver text-gray-spain rounded">
              {list.map((item) => {
                return (
                  <li key={item.id} onClick={() => changeValueoption(item)}>
                    {item.value}
                  </li>
                );
              })}
            </ul>
          )}
        </button>
        {label}
      </p>
    </div>
  );
}

Pagination.defaultProps = {
  list: [
    { id: 1, value: 10 },
    { id: 2, value: 25 },
    { id: 3, value: 50 },
  ],
  items: 10,
  currentPage: 1,
  limit: 10,
  label: 'label per page',
};

Pagination.propTypes = {
  list: propTypes.array,
  items: propTypes.number,
  onPageChange: propTypes.func,
  currentPage: propTypes.number,
  onChangePerPage: propTypes.func,
  label: propTypes.string,
  limit: propTypes.number,
};

export default Pagination;
